// Tooltip copy for the apply-preview tags. The live wizard preview describes
// what an apply *will* do (future tense); the historical Activity drawer
// describes what an apply *did* (past tense). Keeping the copy in one pure,
// testable module lets both modes share the same tag cell.
export type CoaPreviewMode = "preview" | "historical";

export function getAddedGroupTooltip(mode: CoaPreviewMode): string {
    return mode === "historical"
        ? "This group was added when the template was applied."
        : "This group is in the template but not on the entity yet. It will be added when you apply.";
}

export function getAddedAccountTooltip(mode: CoaPreviewMode): string {
    return mode === "historical"
        ? "This account was added when the template was applied."
        : "This account is in the template but not on the entity yet. It will be added when you apply.";
}

export function getReassignedTooltip(
    mode: CoaPreviewMode,
    previousGroupPath: string | null,
): string {
    if (mode === "historical") {
        return previousGroupPath
            ? `This account was moved from the ${previousGroupPath} group to match the template.`
            : "This account was moved to match the template.";
    }
    return previousGroupPath
        ? `This account already exists on the entity and will be moved from ${previousGroupPath} group to match the template.`
        : "This account already exists on the entity and will be moved to match the template.";
}

export function getMovedTooltip(mode: CoaPreviewMode): string {
    return mode === "historical"
        ? "This account's position was changed to match the template's order."
        : "This account already exists on the entity and will only change position to match the template's order.";
}

export function getArchivedTooltip(mode: CoaPreviewMode): string {
    return mode === "historical"
        ? "This account was archived. Existing transactions and journal entries were kept."
        : "This account is archived. Existing transactions and journal entries are kept.";
}
